
import React, { Component } from 'react';

class DemoCard extends Component {

  constructor(props){
      super(props);
  }

  render() {
      if(this.props.id == "registerDemoCard")
      return (
        <div>
        <div className="dashboardCard" id={this.props.id}>
            <div className="dashboardCardBody">
                <img src="img/call.svg" width="55"></img>
                <div className="cardBodyText">Want to know how honeycomb will help you get more customers?</div>
                <a href="https://calendly.com/tamir-barzilai">
                    <button className="RegistrationCardButton">Book a Demo Now</button>
                </a>
            </div>
        </div>
        </div>
        )
      else
      return (
        <div className="OnebyFourcol">
            <div className="dashboardCard" id={this.props.id}>
                <div className="dashboardCardBody">
                    <img src="img/call.svg" width="55"></img>
                    <div className="cardBodyText">Want to know how honeycomb will help you get more customers?</div>
                    <a href="https://calendly.com/tamir-barzilai">
                        <button className="RegistrationCardButton">book a demo now</button>
                    </a>
                </div>
            </div>
        </div>
      )
  }
}

DemoCard.defaultProps = {
  id: "demoCard",
};

export default DemoCard;


// WEBPACK FOOTER //
// ./src/components/DemoCard/DemoCard.js